import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CITY_REDIRECTS } from "@/config/redirects";

export function RedirectHandler() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const normalized = pathname.replace(/\/$/, "") || "/";
    const target = CITY_REDIRECTS[normalized];
    if (target) {
      navigate(target, { replace: true });
    }
  }, [pathname, navigate]);

  return null;
}